import React from 'react'
import { SvgIcon } from '@material-ui/core'

const PlayIcon = (props) => {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37">
      <g data-name="Group 6144" transform="translate(-1094 -1116)">
        <path data-name="Path 14921" d="M1119.8 1135.32a.99.99 0 0 0 0-1.64l-9.23-6.33a1 1 0 0 0-1.57.82v12.66a1 1 0 0 0 1.57.82z" fill="#e6332a" />
        <circle data-name="Ellipse 148" cx="17.5" cy="17.5" r="17.5" transform="translate(1095 1117)" fill="none" stroke="#e6332a" strokeWidth="2px" />
      </g>
    </SvgIcon>
  )
}

export default PlayIcon
